import { Vacations } from 'features/vacations/vacations';
import { useTitle } from '../helpers';

/**
 * @page Vacations
 */
const VacationsPage = () => {
  useTitle('Отпуск');

  return (
    <div>
      <Vacations />
    </div>
  );
};

export default VacationsPage;
